import { memo, MouseEventHandler, ReactEventHandler } from 'react'
import { useUserSelector } from '../../Hooks/useUser'
import PreviewPoster, { PreviewPosterProps } from './PreviewPoster'

type PreviewPosterImageProps = {
    compact?: boolean
    extended?: boolean
    height?: number
    id: number
    large?: boolean
    small?: boolean
    noBackground?: boolean
    onClick?: MouseEventHandler<HTMLDivElement>
    onLoad?: ReactEventHandler<HTMLImageElement>
    onMouseLeave?: MouseEventHandler<HTMLDivElement>
    rounded?: boolean
    setDimensions?: boolean
    showRecommendations?: boolean
    ssr?: boolean
    staticImage?: boolean
    width?: number
}

const PreviewPosterImage = memo((props: PreviewPosterImageProps) => {
    const banned = useUserSelector(props.id, 'banned')
    const channel = useUserSelector(props.id, 'channel')
    const isAway = useUserSelector(props.id, 'isAway')
    const isBroadcasting = useUserSelector(props.id, 'isBroadcasting')
    const isClubShow = useUserSelector(props.id, 'isClubShow')
    const isGroupShow = useUserSelector(props.id, 'isGroupShow')
    const isLounge = useUserSelector(props.id, 'isLounge')
    const isModel = useUserSelector(props.id, 'isModel')
    const isNGVideo = useUserSelector(props.id, 'isNGVideo')
    const isOffline = useUserSelector(props.id, 'isOffline')
    const isPrivateShow = useUserSelector(props.id, 'isPrivateShow')
    const isTruePrivate = useUserSelector(props.id, 'isTruePrivate')
    const streamType = useUserSelector(props.id, 'streamType')
    const phase = useUserSelector(props.id, 'phase')
    const server = useUserSelector(props.id, 'server')
    const privateShow = useUserSelector(props.id, 'privateShow')

    const isLoadingPrivateShow =
        (isPrivateShow || isTruePrivate) &&
        !!privateShow &&
        streamType !== 'voyeur'

    const {
        compact,
        extended,
        height,
        large,
        small,
        noBackground,
        onClick,
        onLoad,
        onMouseLeave,
        rounded,
        setDimensions,
        showRecommendations,
        ssr,
        staticImage,
        width,
    } = props

    const previewPosterProps: PreviewPosterProps = {
        id: props.id,
        banned,
        channel,
        compact,
        extended,
        height,
        isAway,
        isBroadcasting,
        isClubShow,
        isGroupShow,
        isLounge,
        isModel,
        isNGVideo,
        isOffline,
        isLoadingPrivateShow,
        isPrivateShow,
        isTruePrivate,
        large,
        small,
        noBackground,
        onClick,
        onLoad,
        onMouseLeave,
        phase,
        rounded,
        server,
        setDimensions,
        showRecommendations,
        ssr,
        staticImage,
        width,
    }

    return <PreviewPoster {...previewPosterProps} />
})

export default PreviewPosterImage
